import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxTree/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxTree/${id}`,
    method: 'DELETE'
  })
}
export function getObj (id) {
  return axios({
    url: `/sxTree/${id}`,
    method: 'GET'
  })
}
export function addObj (params) {
  return axios({
    url: `/sxTree/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/sxTree/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
